// src/components/MAP/hooks/useIconFilters.js
import { useState, useCallback, useEffect } from 'react';

export const useIconFilters = (customMarkersRef) => {
  const [visibleTypes, setVisibleTypes] = useState({
    civil: true,
    crime: true,
    people: true,
    car: true,
    object: true,
    event1: true,
    event2: true,
    event3: true,
    event4: true,
    event5: true,
    event6: true,
  });

  const toggleIconType = useCallback((type) => {
    const isLastInCategory = (category, currentType) => {
      if (category === 'case') {
        return (currentType === 'civil' && visibleTypes.civil && !visibleTypes.crime) || 
               (currentType === 'crime' && visibleTypes.crime && !visibleTypes.civil);
      }
      else if (category === 'object') {
        return (currentType === 'people' && visibleTypes.people && !visibleTypes.car && !visibleTypes.object) ||
               (currentType === 'car' && visibleTypes.car && !visibleTypes.people && !visibleTypes.object) ||
               (currentType === 'object' && visibleTypes.object && !visibleTypes.people && !visibleTypes.car);
      }
      return false;
    };

    const category = ['civil', 'crime'].includes(type) ? 'case' : 'object';
    
    if (isLastInCategory(category, type) && visibleTypes[type]) {
      return;
    }

    setVisibleTypes((prev) => {
      const newState = { ...prev, [type]: !prev[type] };
      
      newState.event1 = newState.civil && newState.car;
      newState.event2 = newState.civil && newState.people;
      newState.event3 = newState.civil && newState.object;
      newState.event4 = newState.crime && newState.car;
      newState.event5 = newState.crime && newState.people;
      newState.event6 = newState.crime && newState.object;
      
      return newState;
    });

    requestAnimationFrame(() => {
      if (customMarkersRef.current) {
        const updatedState = { ...visibleTypes };
        updatedState[type] = !updatedState[type];
        
        const event1Visible = updatedState.civil && updatedState.car;
        const event2Visible = updatedState.civil && updatedState.people;
        const event3Visible = updatedState.civil && updatedState.object;
        const event4Visible = updatedState.crime && updatedState.car;
        const event5Visible = updatedState.crime && updatedState.people;
        const event6Visible = updatedState.crime && updatedState.object;
        
        customMarkersRef.current.toggleTypeVisibility("event1", event1Visible);
        customMarkersRef.current.toggleTypeVisibility("event2", event2Visible);
        customMarkersRef.current.toggleTypeVisibility("event3", event3Visible);
        customMarkersRef.current.toggleTypeVisibility("event4", event4Visible);
        customMarkersRef.current.toggleTypeVisibility("event5", event5Visible);
        customMarkersRef.current.toggleTypeVisibility("event6", event6Visible);
      }
    });
  }, [visibleTypes, customMarkersRef]);

  return { visibleTypes, toggleIconType };
};